import { HttpErrorResponse, HttpRequest } from '@angular/common/http';
import { UiErrorParser } from '../ui-error-parser';
import { SICOM_PATHS } from 'src/sicom-paths';
import { Injectable } from '@angular/core';

@Injectable()
export class ArrecadacaoErrorParser extends UiErrorParser {
    basePath = SICOM_PATHS.financeiro.arrecadacao.base;
    boletoPath = SICOM_PATHS.financeiro.arrecadacao.boletos;
    creditoPath = SICOM_PATHS.financeiro.arrecadacao.creditos;
    debitoPath = SICOM_PATHS.financeiro.arrecadacao.debitos;
    documentoPath = SICOM_PATHS.financeiro.arrecadacao.documentos;
    isencaoPath = SICOM_PATHS.financeiro.arrecadacao.isencoes;
    negociacaoPath = SICOM_PATHS.financeiro.arrecadacao.negociacao;
    relatoriosPath = SICOM_PATHS.financeiro.arrecadacao.relatorios;

    constructor() {
        super();
        this.setMessageStart('Não foi possível');
        this.setTarget('o(s) boleto(s)');
        this.setType('arrecadacao');
        this.relatoriosPath = this.relatoriosPath.split('/').at(-1)!;
    }

    verifyContext(_error: HttpErrorResponse, req: HttpRequest<unknown>): boolean {
        return req.url.includes(this.basePath) && !req.url.includes(this.relatoriosPath);
    }

    override errorComplement(_error: HttpErrorResponse, _req: HttpRequest<unknown>): string {
        return '';
    }

    override beforeTextBuild(_error: HttpErrorResponse, req: HttpRequest<unknown>): void {
        const url = req.url;
        if (url.includes('banco-conta') && req.method === 'DELETE') {
            this.setIgnore(true);
        } else if (url.includes(this.boletoPath)) {
            this.setTarget('o(s) boleto(s)');
        } else if (url.includes(this.creditoPath)) {
            this.setTarget('o(s) credito(s)');
        } else if (url.includes(this.debitoPath)) {
            this.setTarget('o(s) débito(s)');
        } else if (url.includes(this.documentoPath)) {
            this.setTarget('o(s) documento(s)');
        } else if (url.includes(this.isencaoPath)) {
            this.setTarget('a(s) isenção(ões)');
        } else if (url.includes(this.negociacaoPath)) {
            this.setTarget('a(s) negociação(ões)');
        }
    }
}
